// extracted by mini-css-extract-plugin
export default {"card-grid":"IndividualizationGrid_card-grid__C02eZ"};